import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { createPinia } from 'pinia';
import { key as storeKey, store } from './store/index';
import App from './App.vue';
import router from './router';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/scss/bootstrap.scss';
import 'element-plus/dist/index.css';
import '@/assets/reset.css';
import '@/assets/index.scss';
import '@/scss/theme/wshoto.scss';
import { MyWWSDK } from '@/mixin/wecomJSSDK';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(store, storeKey).use(router).use(ElementPlus, { locale: zhCn }).mount('#app');
for (let i = 0; i < Object.entries(ElementPlusIconsVue).length; i += 1) {
  const [key, component] = Object.entries(ElementPlusIconsVue)[i];
  app.component(key, component);
}
// app.use(privateApp);
window['myWW'] = MyWWSDK;
export const myApp = app;
